import { replaceAntiForgeryToken } from '../../functions/add-antiforgery-token';
import { LoadingIndicator } from './../loading-indicator/loading-indicator';
import { Component } from '@opten/compiler/metadata/component';
// Ensure the correct path to the module or create the module if it doesn't exist


@Component({ className: 'js-vehicle-storage-pdf', observe: true })
export class VehicleStoragePdfComponent {

    loadingIndicatorDark: string;
    loadingIndicator: string;
    contentElement: HTMLElement;
    wrapperElement: HTMLElement;
    formElementWrapper: HTMLElement;
    targetToLoad: string;
    language: string;
    formElement: HTMLFormElement;

    constructor(private element: HTMLElement) {
        this.loadingIndicatorDark = new LoadingIndicator().contentLoadingDarkMini;
        this.loadingIndicator = new LoadingIndicator().contentLoadingMini;
        this.contentElement = element;
        this.init();
    }

    init() {
        this.targetToLoad = this.contentElement.getAttribute('data-load');
        var dataLanguage = document.body.getAttribute('data-language-long');
        if (dataLanguage && dataLanguage.length > 0) {
            this.language = dataLanguage;
        }
        this.wrapperElement = this.contentElement.parentElement as HTMLElement;
        this.contentElement.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleLoadContent();
        });
    }

    private handleLoadContent(): void {
        // Hide the button and show loading indicator
        this.contentElement.classList.add('d-none');
        const loadingIndicator = this.wrapperElement.classList.contains('c-vehicle-storage__pdf-wrapper--mobile')
            ? this.loadingIndicator
            : this.loadingIndicatorDark;
        this.wrapperElement.insertAdjacentHTML('beforeend', loadingIndicator);

        fetch(this.targetToLoad, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'accept-language': this.language,
                // todo: why? if we change to a api controller we don't have this problem...
                'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
            },
            credentials: 'include'
        })
            .then(response => {
                // Remove the loading indicator
                const loadingEl = this.wrapperElement.querySelector('.c-loading-indicator');
                if (loadingEl) {
                    loadingEl.remove();
                }

                if (response.status === 404 || response.status === 400) {
                    return response.text().then(message => {
                        this.wrapperElement.insertAdjacentHTML('beforeend', `<div class="alert alert-danger"><p>${message}</p></div>`);
                        this.contentElement.classList.remove('d-none');
                    });
                }

                if (!response.ok) {
                    this.wrapperElement.insertAdjacentHTML('beforeend', `<div class="alert alert-danger"><p>An unexpected error occurred.</p></div>`);
                    this.contentElement.classList.remove('d-none');
                    return;
                }

                return response.blob().then(blob => {
                    const url = URL.createObjectURL(blob);

                    if (blob.type === 'application/pdf') {
                        // Try to open and print the PDF
                        const printWindow = window.open(url);
                        if (printWindow) {
                            printWindow.addEventListener('load', () => {
                                printWindow.print();
                            });
                        } else {
                            // Fallback: download if popup is blocked
                            this.downloadBlob(url, blob);
                        }
                    } else {
                        this.downloadBlob(url, blob);
                    }

                    // Show the button again
                    this.contentElement.classList.remove('d-none');
                });
            })
            .catch(() => {
                // Remove the loading indicator
                const loadingEl = this.wrapperElement.querySelector('.c-loading-indicator');
                if (loadingEl) {
                    loadingEl.remove();
                }

                this.wrapperElement.insertAdjacentHTML('beforeend', `<div class="alert alert-danger"><p>An unexpected error occurred.</p></div>`);
                // Show the button again
                this.contentElement.classList.remove('d-none');
            });
    }

    private downloadBlob(url: string, blob: Blob): void {
        const a = document.createElement('a');
        a.href = url;
        a.download = 'vehicle.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }



}